import { AssetAmount } from "@sundaeswap/asset";
import { useMemo } from "react";
import { ADA_METADATA } from "../../constants/cardano.constants";
import { useTasteTestContext } from "../../pages/TasteTestDetail/context";

export const useCurrentTasteTestContribution = () => {
  const {
    derived: { latestHistoryRecord },
  } = useTasteTestContext();

  return useMemo(() => {
    if (latestHistoryRecord) {
      return new AssetAmount(latestHistoryRecord?.depositCumulative[0].amount, ADA_METADATA);
    }
    return new AssetAmount(0n, ADA_METADATA);
  }, [latestHistoryRecord?.depositCumulative]);
};
